import React, { useRef,useEffect,useState } from 'react';
import { ChevronLeft, ChevronRight } from 'lucide-react';
import { genrateAvatarImageLink } from '../utils';
import StreamWebService from '../classes/StreamWebService';
import { Link } from 'react-router-dom';

const ChannelsScroll = () => {
    const scrollRef = useRef(null);
    const sWeb = new StreamWebService()
    const [channels, setchannels] = useState([])
    const fetchCategories = () => {
        sWeb.getChannels().then(res => setchannels(res.data))
      }


      useEffect(() => {
        fetchCategories();
      }, [])
      

    const scroll = (direction) => {
        if (scrollRef.current) {
            const scrollAmount = direction === 'left' ? -200 : 200;
            scrollRef.current.scrollBy({
                left: scrollAmount,
                behavior: 'smooth'
            });
        }
    };

    return (
        <div className="relative  w-full">
            <div className="flex items-center">
                <button
                    onClick={() => scroll('left')}
                    className="absolute left-0 z-10 p-2 bg-black/60 text-white hover:bg-black/80 transition-colors h-full"
                    aria-label="Scroll left"
                >
                    <ChevronLeft className="w-5 h-5" />
                </button>

                <div
                    ref={scrollRef}
                    className="flex overflow-x-auto scrollbar-hide  py-2 px-4 md:py-4 md:px-8 lg:py-4 lg:px-8  space-x-4 scroll-smooth mx-auto"
                    style={{
                        msOverflowStyle: 'none',
                        scrollbarWidth: 'none'
                    }}
                >
                    {channels.map((channel) => {
                        const fallbackImageUrl = genrateAvatarImageLink(channel.name)
                        return <div
                            key={channel.id}
                            className="flex-shrink-0 group cursor-pointer w-16 h-16 sm:w-20 sm:h-20 "
                        >
                            <Link to={`/channel/${channel.id}`}>


                            <div className="relative w-10 h-10 sm:w-14 sm:h-14 mx-auto">
                                <object data={channel.image ?? fallbackImageUrl} type="image/jpeg" className="w-full h-full rounded-full object-cover border-2 border-transparent group-hover:border-purple-500 border-purple-200 transition-all duration-200">
                                    <img src={fallbackImageUrl} alt={channel.name} />
                                </object>

                                {channel.is_streaming && (
                                    <div className="absolute -bottom-1 left-1/2 transform -translate-x-1/2">
                                        <div className="flex items-center space-x-1 bg-red-600 px-2 py-0.5 rounded-full">
                                            <div className="w-1.5 h-1.5 rounded-full bg-white animate-pulse"></div>
                                            <span className="text-white text-xs font-medium">{channel.totalViews}</span>
                                        </div>
                                    </div>
                                )}
                            </div>
                            <p className="mt-2 text-center  text-white text-xs md:text-sm font-normal md:font-medium truncate max-w-[96px] md:max-w-[112px]">
                                {channel.name}
                            </p>
                          
                        </Link>
                        </div>

                    })}
                </div>

                <button
                    onClick={() => scroll('right')}
                    className="absolute right-0 z-10 p-2 bg-black/60 text-white hover:bg-black/80 transition-colors h-full"
                    aria-label="Scroll right"
                >
                    <ChevronRight className="w-5 h-5" />
                </button>
            </div>
        </div>
    );
};

// Add custom CSS to hide scrollbar
const styles = `
  .scrollbar-hide::-webkit-scrollbar {
    display: none;
  }
  .scrollbar-hide {
    -ms-overflow-style: none;
    scrollbar-width: none;
  }
`;

// Insert styles into document head
const styleSheet = document.createElement("style");
styleSheet.innerText = styles;
document.head.appendChild(styleSheet);

export default ChannelsScroll;